import TopBarRow from "@common/components/entityDetailTopBar/TopBarRow";
import TopBarTextTile from "@common/components/entityDetailTopBar/TopBarTextTile";
import { useTranslation } from "@localization/useTranslation";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useUrlProvider } from "../../useUrlProvider";
import QuestionnaireTemplateLink from "../../legalEntity/legalEntityAuditTab/QuestionnaireTemplateLink";
import { InternalAssessmentGroupHeaderModel } from "../InternalAssessmentGroups.types";

export interface IInternalAssessmentGroupTopBarRowProps {
    data?: InternalAssessmentGroupHeaderModel;
    status: string;
    isLoading: boolean;
}

// Shared by the draft overview and the sent overview, which differ only in how they phrase the status.
function InternalAssessmentGroupTopBarRow(props: IInternalAssessmentGroupTopBarRowProps) {
    const { customerName } = useUserContext();
    const { translateString, translateDate } = useTranslation();
    const { getGroupEntityUrl } = useUrlProvider();
    const { data, isLoading } = props;

    return (
        <TopBarRow>
            <TopBarTextTile label={translateString("status")} isLoading={isLoading} value={props.status} />
            <TopBarTextTile label={translateString("sent")} isLoading={isLoading} value={data?.sent ? translateDate(data.sent) : ""} />
            <TopBarTextTile
                label={translateString("assessmentTemplate")}
                isLoading={isLoading}
                value={data ? <QuestionnaireTemplateLink type={"audit"} id={data.assessmentTemplateId} name={data.assessmentTemplate} /> : ""}
            />
            <TopBarTextTile label={translateString("deadline")} isLoading={isLoading} value={data ? translateDate(data.deadline) : ""} />
            <TopBarTextTile label={translateString("responsible")} isLoading={isLoading} value={data?.responsible ?? ""} />
            <TopBarTextTile
                label={translateString("sentFrom")}
                isLoading={isLoading}
                value={data?.sender ?? customerName}
                linkTo={data?.senderId ? getGroupEntityUrl(data.senderId) : undefined}
            />
        </TopBarRow>
    );
}

export default InternalAssessmentGroupTopBarRow;
